<template>
  <custom-dialog
    class="parts-location-item-dialog"
    width="1000px"
    :title="model.title"
    :visible="visible"
    :appendToBody="true"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <div class="content">
        <div class="form-content">
          <div class="item-title">{{i18n.page_content_product_info}}</div>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item :label="i18n.label_product_code" prop="productCode">
              <custom-select
                url="productCodeSelectList"
                v-model="form.productCode"
                :props="{ label: 'productCode', value: 'productCode' }"
                width="100%"
                @getList="initProudctList"
                @change="onProductChange"
                :disabled="forbidden"
              ></custom-select>
            </el-form-item>
            <el-form-item :label="i18n.label_part_name" prop="componentCode">
              <custom-select
                  url="productStructureList"
                  type="tree"
                  :listener="form.productCode"
                  :auto="false"
                  v-model="form.componentCode"
                  :show-all-levels="false"
                  :params="{productSn: form.productSn,productCode:form.productCode}"
                  :props="{
                    label: 'componentName',
                    value: 'componentCode',
                    emitPath: false
                  }"
                  width="100%"
                  ref="component"
                  :disabled="forbidden"
                  @treeValChange="getInfo"
                ></custom-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="part-info">
          <div class="item-title">{{i18n.page_content_part_information}}</div>
          <div class="table-bd">
            <custom-table
              height="400px"
              :data="tableList"
              tableCode="parts_location_info"
              @sort="sortChange"
              @filter="filterChange"
              :slots="['action']"
              :filterArr="forbidden ? ['action'] : []"
            >
              <template v-slot:action="scope">
                <el-button
                  v-if="!forbidden"
                  type="text"
                  size="mini"
                  @click="onDel(scope.row,scope.$index)"
                >{{i18n.com_delete}}</el-button>
              </template>
            </custom-table>
          </div>
          <div
            v-if="!forbidden"
            class="add-row"
            @click="addRow"
          ><i class="el-icon-plus el-icon--left"></i>{{i18n.com_add_to}}</div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">
        {{i18n.com_cancel}}
      </el-button>
      <el-button
        v-if="!forbidden"
        type="primary"
        @click="onConfirm"
      >
        {{i18n.com_confirm}}
      </el-button>
    </div>
    <select-part-dialog
      v-if="selectPartDialogVisible"
      @close="selectPartDialogVisible=false"
      @confirm="onSelectPart"
      :productCode="form.productCode"
      :componentCode="form.componentCode"
      :model="selectPartDialogModel"
    ></select-part-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';
import selectPartDialog from './select_part_dialog';

export default {
  mixins: [dialogMixins, languageInjectMixins],
  props: {
    // model: {
    //   type: '', add: 新增 edit: 编辑 watch: 查看
    //   data: { productCode, componentCode }
    // }
  },
  components: { selectPartDialog },
  computed: {
    rules() {
      return {
        productCode: { required: true, message: this.$t('asm_partsLocation_item_dialog.qxzcpmc') },
        componentCode: { required: true, message: this.$t('asm_partsLocation_item_dialog.qxzbjmc') },
      };
    },
    forbidden() {
      return this.model.type === 'watch';
    },
  },
  data() {
    return {
      form: {
        productCode: '',
        productSn: '',
        componentCode: '',
      },
      productList: [],
      componentList: [],
      tableList: [],
      tableListDelete: [],

      selectPartDialogVisible: false,
      selectPartDialogModel: {},
      // 零件信息列表副本，用于对比，计算deleteFlag
      copyList: [],
    };
  },
  mounted() {},
  methods: {
    onDel(row, index) {
      const tips = this.i18n.msg_tips_delete_part;
      this.$showConfirm(tips).then(() => {
        this.tableList.splice(index, 1);
        this.tableListDelete.push({ ...row, deleteFlag: true });
      });
    },
    onSelectPart(list) {
      const appendList = list.filter(item => !this.tableList.some(obj => obj.partId === item.partId));
      this.tableList.push(...appendList);
    },
    addRow() {
      if (this.form.productCode) {
        this.selectPartDialogModel = {
          title: this.i18n.dialog_title_select_parts
        };
        this.selectPartDialogVisible = true;
      }
    },
    initProudctList(list) {
      this.productList = list;
      this.init();
    },
    onProductChange(data) {
      this.form.productSn = data.productSn;
      this.form.componentCode = '';
    },
    closeDialog() {
      this.visible = false;
    },

    create() {
      const reqData = {
        componentCode: this.form.componentCode,
        productCode: this.form.productCode,
        partList: this.tableList,
      };
      this.$postJSON(apis.partLocationSetup, reqData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.i18n.com_add_success
        });
        this.closeDialog();
        this.$emit('add');
      });
    },
    getSaveReqData() {
      const reqData = {
        componentCode: this.form.componentCode,
        productCode: this.form.productCode,
        partList: [...this.tableList, ...this.tableListDelete],
      };
      return reqData;
    },

    save() {
      const reqData = this.getSaveReqData();
      this.$postJSON(apis.partLocationSetup, reqData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.i18n.com_edit_success
        });
        this.closeDialog();
        this.$emit('edit');
      });
    },

    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.tableList.length === 0) {
            this.$message.error(this.i18n.rule_tips_Please_add_parts);
            return;
          }
          if (this.model.type === 'add') {
            this.create();
          } else {
            this.save();
          }
        }
      });
    },
    getInfo() {
      const reqData = {
        productCode: this.form.productCode,
        componentCode: this.form.componentCode,
      };
      this.$getJSON(apis.partlocationPartPage, reqData).then((res) => {
        this.tableList = res.data;
        this.copyList = [...res.data];
      });
    },
    init() {
      if (this.model.type !== 'add') {
        const { productCode, componentCode } = this.model.data;
        const productItem = this.productList.find(obj => obj.productCode === productCode);
        this.form.productCode = productCode;
        this.form.componentCode = componentCode;
        if (productItem) {
          this.form.productSn = productItem.productSn;
        }
        this.getInfo();
      }
    },
  },
};
</script>

<style lang="scss">
.parts-location-item-dialog {
  .content {
    overflow: hidden;
    display: flex;
    .form-content {
      width: 30%;
      padding-right: 15px;
      flex-shrink: 0;
    }

    .part-info {
      flex: 1;
      padding-left: 15px;
      border-left: 1px solid #ccc;

      .add-row {
        margin-top: 16px;
        width: 100%;
        background: #f5f5f7;
        border: 1px #e4e4e4 dashed;
        height: 40px;
        line-height: 38px;
        text-align: center;
        font-size: 12px;
        color: #495057;
        &:hover {
          cursor: pointer;
        }

        .el-icon-plus {
          color: #0d9ae0;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
